"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = nSeriesDataToHighchartsData;

require("core-js/modules/es6.function.name");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

var _coerce = _interopRequireDefault(require("@meltwater/coerce"));

var _seriesData = _interopRequireDefault(require("../../series-data"));

var _seriesDataValue = _interopRequireDefault(require("../../series-data-value"));

/**
 * @protected
 *
 * A helper function to convert passed SeriesData into the appropriate options to pass to Highcharts
 *
 * @param {SeriesData[]} chartData - an array of SeriesData
 *
 * @returns {object} - An object containing the series and categories to assign to a Highcharts chart object.
 */
function nSeriesDataToHighchartsData(chartData) {
  var categories = [];
  var series = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    var _loop = function _loop() {
      var seriesData = _step.value;
      (0, _coerce.default)(seriesData, _seriesData.default, "chartData must be valid SeriesData. Provided ".concat(JSON.stringify(seriesData)));
      var highchartsSeries = {
        name: seriesData.name,
        data: []
      };
      seriesData.data.forEach(function (point) {
        if (categories.indexOf(point.key) === -1) {
          categories.push(point.key);
        }

        var value = point.value;

        if (value === _seriesDataValue.default.NO_DATA) {
          value = null;
        }

        highchartsSeries.data.push(value);
      });
      series.push(highchartsSeries);
    };

    for (var _iterator = chartData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      _loop();
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return {
    categories: categories,
    series: series
  };
}